import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import '../../Lg.css';

export function TildaB(props) {
    return (
        <div>
            <Row>
                <Col>
                    <br/>
                    <div>
                        {props.children}
                    </div>
                    <br/>
                </Col>
            </Row>
        </div>
    );
}

